import { Actions } from "../Actions/Actions";

const initialState = {
    senderAndTravelerInfo: [],
    homePageData: [],
    faqsList: [],
    cityList: [],
    searchFilter: [],
};


const homeReducer = (state = initialState, action) => {
    switch (action.type) {
        case Actions.FETCH_HOME_PAGE_DATA_SUCCESS:
            return {
                ...state,
                senderAndTravelerInfo: action.data.senderAndTravelerInfo,
                homePageData: action.data.homePageData,
                faqsList: action.data.faqsList,
                cityList: action.data.cityList,
            };

        case Actions.FETCH_HOME_PAGE_DATA_FAILURE:
            return {
                ...state,
                senderAndTravelerInfo: [],
                homePageData: [],
                faqsList: [],
                cityList: [],
            };
        default:
            return state;
    }
};

export default homeReducer;
